import React from 'react'
import Moment from 'react-moment'
import { StatusTag } from 'components'
import { DivText } from './styled'

export const rfqStatus = {0:'Draft',2:'In Progress',3:'Revise',4:'Completed',5:'Reject',6:'Cancelled',7:'Error',9:'Deleted'}

export const columns = { 
  tRFQs:[
    {
      Header: 'Status',
      accessor: 'status',
      width: 100,
      Cell:row=>(<DivText><StatusTag status={row.value} statusName={rfqStatus[row.value]}/></DivText>)
    },{
      Header: 'Doc No.',
      accessor : row =>(row.status === 0 ? '-' : row.docNo),
      id:'docNo',
      width: 100,
      Cell:row=>(<DivText>{row.value}</DivText>)
    },{
      Header: 'PR No.',
      accessor : 'prDocNo',
      width: 100,
      className: 'left'
    },{
      Header: ()=>(<DivText left>Title</DivText>),
      accessor : row =>(row.title.trim()),
      id:'title',
      width: 250
    }, {
      Header: ()=>(<DivText left>Project name</DivText>),
      accessor: 'projectName',
      width: 100,
      Cell:row=>(<DivText left>{row.value}</DivText>)
    },{
      Header: 'Vendor',
      accessor: 'vendorName',
      width: 100,
      Cell:row=>(<DivText left>{row.value}</DivText>)
    },{
      Header: 'Company',
      accessor : 'companyName',
      width: 100,
      Cell:row=>(<DivText left>{row.value}</DivText>)
    },{
      Header: 'Priority',
      accessor: 'priority',
      width: 70,
      Cell: row => (
        row.value && 
        <DivText>
          <div className={`priority ${row.value}`}>
            {row.value.toUpperCase()}
          </div>
        </DivText>)
    },{
      Header: ()=>(<DivText left>Requester</DivText>),
      accessor: 'requesterName',
      width: 100,
      Cell: row => (row.value&&<DivText left>{`${row.value||'-'}`}</DivText>)
    },
    // {
    //   Header: 'Overdue',
    //   id:'overdue',
    //   accessor : row =>(Math.floor(row.pendingDays-row.slaDays)),
    //   width: 70,
    //   Cell: row => (<DivText>{`${ row.value>=1?`(${row.value} days)`:'-'}`}</DivText>)
    // }, 
    // SLA Status
    // SLA Remaining
    {
      Header: 'Submitted date',
      accessor: 'submittedDate',
      width: 120,
      Cell: row => (row.value&&
        <DivText>
          {row.value?
            <Moment format="DD MMM YYYY HH:mm">{row.value}</Moment>
            :
            '-'
          }
        </DivText>)
    }, {
      Header: 'Modified date',
      accessor: 'modifiedDate',
      width: 120,
      Cell: row => (row.value&&<DivText><Moment format="DD MMM YYYY HH:mm">{row.value}</Moment></DivText>)
    }
  ],
}